import styled from 'styled-components';
import css from "@styled-system/css";


export const Container = styled.div`
  background-color: #9cc54b;
  color: #fff;
  position: relative;
  top: 100px;
  width: 100%;
`;

export const NavMenuContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0px auto;
    height: 50px;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    max-width: 1400px;

    // @media (max-width: 1200px) {
    //   max-width: 992px;
    // }

    // @media (max-width: 992px){
    //   max-width: 750px;
    // }
`;

export const ListNavMenu = styled.ul `
    display: flex;
    list-style: none;
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0;
`;
export const NavMenuItem = styled.li `
    height: 100%;
    &.best-deal {
      a {
        font-size: 12px;
        // display: flex;
        // flex-direction: column;        
      }

      a svg {
        width: 24px;
        height: 24px;
        margin-right: 5px;
      }
    }
`;
export const NavMenuLink = styled.a `
    pointer-events: auto;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 2px;
    height: 100%;
    padding: 0px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
    text-decoration: none;
    color: white;
    cursor: pointer;

    span {
      pointer-events: none;
    }
    &:hover {
      background-color: #61791a;
      text-decoration: none;
      color: #fff;
    }

`;

export const NavBrandContainer = styled.div`
  height: 100%;

  a {
    padding: 5px;
    background-color: #4b4a49;
  }

  .menu-name-container {
    width: 100%;
    height: 100%;
    padding: 0 18px;
    border: 1px solid #9cc54b;
    display: inline-flex;
    align-items: center;
    pointer-events: none;
  }

;`

export const DropDownContainer = styled.div`
  position: absolute;
  top: 150px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px;
  display: none;

  max-height: 90vh;
  padding-bottom: 40px;
  overflow: auto;

  &.active {
    display: block;
  }
`
export const DropDownMenu = styled.div`
  display: none;
  width: 100vw;
  padding: 20px;
  
  &.active {
    display: flex;
  }
  &.active#brand-menu {
    display: block;
  }

  .row {
    max-width: 1200px;
    margin: 0 auto 0 auto;
  }

`;
export const DropDownMenuLeft = styled.div`
  flex: 0 0 20%;
  max-width: 20%;
  img {
    width: 100%;
  }
`;
export const DropDownMenuRight = styled.div`
  flex: 0 0 80%;
  // padding: 15px 30px;
  max-width: 80%;
  &.row {
    max-width: 100%;
    margin: 0 auto 0 auto;
  }
  @media screen and (min-width: 1440px) {
    &.row {
      max-width: 70%;
    }
  }
`;

export const MenuBanner = styled.div`
display: flex;
flex-direction: column;
height: 100%;
width: 100%;
  img {
    width: 100%;
  }
`

export const MenuBannerButton = styled.a`
  // border: 2px solid #9cc54b;
  text-align: center;
  color: #fff;
  width: 100%;
  padding: 5px;
  margin-bottom: 15px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 700;

  &.new-arrivals {
    background-color: #9fbe44;
    &:hover {
      color: #9fbe44;
    }
  }
  &.promotions {
    background-color: #6e842d;
    &:hover {
      color: #6e842d;
    }
  }
  &.best-sellers {
    background-color: #4b4a49;
    &:hover {
      color: #4b4a49;
    }
  }
  div {
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
    pointer-events: none;
    padding: 10px 0;
    transition: transform .25s ease-in-out;
  }

  &:hover {
    transition: transform .25s ease-in-out;
    text-decoration: none;
    div {
      background-color: #fff;
      transition: transform .25s ease-in-out;
    }
  }

`
// export const WrapperBrand = styled.div`
//   width: 100vw;
//   /* max-width: calc(100vw - 100px); */
//   /* height: 100vh; */
//   overflow: auto;
//   display: flex;
//   flex-direction: column;
//   /* align-items: center; */
//   justify-content: center;
// `;
export const BrandsContainer = styled.div`
  min-width: 991px;
  max-width: 1400px;
  width: 90%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(280px, 1fr));
  /* justify-content: center; */
  /* justify-self: center; */
  grid-auto-flow: row dense;
  justify-content: center;
  @media(max-width: 1280px){
  grid-template-columns: repeat( auto-fit, minmax(230px, 1fr));

  }
  /* max-height: calc(100vh - 200px); */
  /* overflow-y: auto; */
`;

export const BrandLink = styled.a`
  display: flex;
  flex-direction:row;
  /* justify-content: center; */
  align-items: center;
  pointer-events: auto;
  text-transform: uppercase;
  font-weight: 500;
  height: 100px;
  margin-top: 5px;
  padding: 5px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  transition: background-color 0.3s ease;
  text-decoration: none;
  color: #212529;
  cursor: pointer;
  gap: 10px;
 @media(max-width: 1280px){
    font-size: 14px;
    padding: 2px;
    margin-top: 2px;
  }
  span {
    pointer-events: none;
    // margin-left: 5px
  }
  &:hover {
    text-decoration: none;
    color: #212529;
    // font-weight: 700;
    background-color: #f1f1f1;
  }
  img {
    width: 70px;
    height: 70px;
    object-fit: scale-down;
     @media(max-width: 1280px){
      width: 50px;
      height: 50px;
    }
  }
`
export const BrandsLink = styled.a`
  margin: auto;
  color: #9cc54b;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    color: #4b4a49;
  }
`

export const ExpressLogo = styled.div`
  height: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
  .first {
    height: 100%;
    width: 30px;
    border-radius: 3px 0 0 3px;
    background-color: #f01266;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    span {
      width: 20px;
      letter-spacing: 1px;
      line-height: 0.9;
    }
    span.to{
      padding-left: 0.5px;
      letter-spacing: 2px;
    }
  }
  .second {
    height: 100%;
    background-color: #fff;
    padding: 5px;
  }
  .third {
    width: 0;
    height: 0;
    border-top: 40px solid #fff;
    border-right: 40px solid transparent;
  }
  .fourth {
    width: 70px;
    height: 0;
    border-top: 40px solid #ffffff6e;
    border-right: 40px solid transparent;
    margin-left: -40px;
  }

`



// export const Header = styled.header(
//     (props) =>
//       css({
//         fontSize: props.depth === "parent" ? [2] : [1],
//         fontWeight: 6,
//         display: "flex",
//         alignItems: "center",
//         // marginBottom: props.depth === 'parent' ? 12 : 0,
//         color:
//           props.depth === "parent"
//             ? props.open
//               ? props.cartType === 'express' ? "#f01266" : "primary"
//               : "darkBold"
//             : props.open
//             ? props.cartType === 'express' ? "#f01266" : "primary"
//             : "darkRegular",
//         cursor: "pointer",
//         transition: "0.15s ease-in-out",
  
//         "&:hover": {
//           color: props.cartType === 'express' ? "#f01266" : "primary",
//         },
//       }),
//     {
//       padding: "5px 0",
//       outline: 0,
//     }
//   );
  
//   export const IconWrapper = styled.div(
//     (props) =>
//       css({
//         width: props.depth === "child" ? 10 : 16,
//         // marginRight: props.depth === 'child' ? '8px' : 15,
  
//         svg: {
//           width: "100%",
//           height: props.depth === "child" ? "2px" : "auto",
//         },
//       }),
//     {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       overflow: "hidden",
//       flexShrink: 0,
//     }
//   );
  
//   export const Title = styled.span({
//     textOverflow: "ellipsis",
//     whiteSpace: "nowrap",
//     verticalAlign: "middle",
//     overflow: "hidden",
//     marginLeft: "5px",
//   });

// export const NavMenuContainer = styled.div`
//     position: relative;
//     top: 70px;
//     left: 0;
//     width: 100% !important;
//     background-color: #9cc54b;
//     display: -webkit-box;
//     // display: inline;
//     justify-content: center;
//     box-shadow: 0 1px 2px rgb(0 0 0 / 6%);

//     .scroll {
//         overflow-x:auto;
//         display: -webkit-box;
//         -ms-overflow-style: none;
//         scrollbar-width: none;
//     }
//     .scroll::-webkit-scrollbar{
//         display: none;
//     }
//     @media screen and (max-width: 990px) {
//         display: none;
//     }
// `;

// export const NavMenuItem = styled.div`
//     padding: 5px 10px 5px 20px;
//     cursor: pointer;
//     color: #fff;

//     .item-button {
//         display: flex;
//         align-items: flex-end;
//         pointer-events: none;
//         font-size: 20px;
//         font-weight: 900;
//     }

//     .item-dropdown {
//         display: none;
//         opacity: 0;
//         position: absolute;
//         min-width: 200px;
//         background-color: #fff;
//         color: #000;
//         padding: 20px;
//         box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
//         box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
//         border-radius: 5px;
//         width: max-content;
//         overflow-y: auto;
//         transition: opacity 2s ease-in-out;
//     }
//     .item-dropdown .collapse div {
//       max-height: 400px;
//       overflow-y: auto;
//       font-size: 16px;
//       transition: font-size 0s;
//     }
//     &:hover {
//         background-color: #317a3a;
//     }
//     &:hover .item-dropdown{
//         opacity: 1;
//         display: block;
//         transition: opacity 2s ease-in-out;
//     }
// `